<template>
  <div>
    <!-- TOP BAR -->
    <v-app-bar
      app
      fixed
      dense
      clipped-left
      elevation="0"
      flat
      style="background-color: #fff"
    >
      
            <v-app-bar-nav-icon @click.stop="sidebarMenu = !sidebarMenu"><v-icon>mdi-menu</v-icon></v-app-bar-nav-icon>
            <v-toolbar-title>
                <v-img src="@/assets/knapp_logo.svg" max-height="28" width="100" contain alt="KNAPP" ></v-img>
            </v-toolbar-title>
           

      <v-spacer></v-spacer>

      <v-btn small text :to="{ name: 'myAccount' }" class="top-nav__btn" color="secondary">
        {{ username }}
        <v-icon right class="top-nav__icon">mdi-account-circle</v-icon>
      </v-btn>

      <v-divider class="mx-1" vertical></v-divider>

      <v-btn small text @click="openHelp()" class="top-nav__btn" color="secondary">
        <lang t="GLOBAL-HELP" />
        <v-icon right class="top-nav__icon">mdi-help-circle-outline</v-icon>
      </v-btn>

      <v-divider class="mx-1" vertical></v-divider>

      <v-btn small text @click="logout" class="top-nav__btn" color="secondary">
        <lang t="GLOBAL-LOGOUT">logout</lang>
        <v-icon right class="top-nav__icon">mdi-power</v-icon>
      </v-btn>
    </v-app-bar>

    <!-- NAVIGATION -->
    <v-navigation-drawer
      v-model="sidebarMenu"
      :permanent="sidebarMenu"
      :mini-variant.sync="mini"
      :clipped="true"
      app
      color="#666666"
      dark
      width="220"
      class="pt-2"
    >

      <v-list dense>
        <template v-for="item in items">
          <template v-if="item == '-'">
            <v-divider class="my-2"></v-divider>
            <div class="py-2"></div>
          </template>

          <template v-else >
            <template v-if="item.items" style="display: flex; justify-content: space-between">
              <v-list-group :key="item.title" no-action active-class="navbar-item-active" color="#404046">

                  <template v-slot:appendIcon>                    
                <v-icon small color="#fff">mdi-chevron-down</v-icon>

                  <v-icon small color="#fff">{{ item.icon }}</v-icon>
                  </template>

                <template v-slot:activator>
                  <v-list-item-content class="dropdownNavTitle">
                    <v-list-item-title 
                      ><lang :t="item.title" /></v-list-item-title>
                  </v-list-item-content>
                </template>


                <!-- SubMenu Items -->
                <v-list-item
                  active-class="navbar-item-active"
                  v-for="subItem in item.items"
                  :key="subItem.title"
                  :to="{ name: subItem.link }"
                >
                  <v-list-item-content>
                    <v-list-item-title
                      ><lang :t="subItem.title"></lang
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </template>

            <template v-else>
              <v-list-item
                dense
                active-class="navbar-item-active"
                :key="item.title"
                link
                :to="{ name: item.link }"
                :exact="item.isExact ? item.isExact : false"
              >
               
                <v-list-item-content>
                  <v-list-item-title
                    ><lang :t="item.title"></lang
                  ></v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon >
                  <v-icon small color="#fff" >{{ item.icon }}</v-icon>
                </v-list-item-icon>

              </v-list-item>
            </template>
          </template>
        </template>
      </v-list>
      
      <div class="versions" v-if="version">
        
        <router-link class="releaseNotes" tag="div" :to="{ name: 'releaseNotes' }" style="cursor: pointer;"
        >{{ $t('Genomix v') }}{{ version.genomix }}</router-link>
        <span>{{ $t('ADM API v') }}{{ version.adm_api }}</span>
      </div>
    </v-navigation-drawer>

    <v-dialog v-model="openHelpModal" width="640">
      <v-card>
        <!-- TEXT -->
        <v-card-text class="pa-4" v-html="helpText" />

        <!-- DIALOG ACTIONS -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="openHelpModal = false"
            ><lang t="GLOBAL-BTN-CLOSE"></lang
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'TheNavigation',
  data: () => ({
    dialog: false,
    clipped: true,
    toggleMini: false,
    sidebarMenu: true,
    openHelpModal: false,
    helpText: null,
    items: [],
    version: null,

    smItems: [
      { title: "MENU-ARTICLES", icon: "mdi-sitemap", link: "items" },
      { title: "MENU-WAREHOUSE", icon: "mdi-domain", link: "warehouses" },
    ],

    opItems: [{ title: "MENU-ARTICLES", icon: "mdi-sitemap", link: "items" }],

    admItems: [
      {
        title: "MENU-DASHBOARD",
        icon: "mdi-monitor-dashboard",
        link: "dashboard",
        isExact: true,
      },
      "-",
      { title: "MENU-ARTICLES", icon: "mdi-sitemap", link: "items" },
      { title: "MENU-BUNDLE_GROUPS", link: "settings-bundle_groups" },
      { title: "MENU-DERIVATION_RULES", link: "settings-derivation_rules" },
      { title: "MENU-WAREHOUSE", icon: "mdi-domain", link: "warehouses" },
      {
        title: "MENU-USER_MANAGEMENT",
        icon: "mdi-account-group",
        link: "userManagement",
      },
    ],

    prdSysSupItems: [
      { title: "MENU-ARTICLES", icon: "mdi-sitemap", link: "items" },
    ],

    allItems: [
      {
        title: "MENU-DASHBOARD",
        icon: "mdi-monitor-dashboard",
        link: "dashboard",
        isExact: true,
      },
      { title: "MENU-ARTICLES", icon: "mdi-sitemap", link: "items" },
      {
        title: "MENU-CLIENTS",
        icon: "mdi-briefcase-account-outline",
        link: "clients",
      },

      "-",
      { title: "MENU-WAREHOUSE", icon: "mdi-domain", link: "warehouses" },
      {
        title: "MENU-CONFIGURATION",
        icon: "mdi-tune",
        link: "settings",
        items: [
          { title: "MENU-SETTINGS", link: "settings-settings" },
          { title: "MENU-BUNDLE_GROUPS", link: "settings-bundle_groups" },
          { title: "MENU-DERIVATION_RULES", link: "settings-derivation_rules" },
          { title: "MENU-ATTRIBUTES", link: "settings-attributes" },
          {
            title: "MENU-PACKAGING_CLASSES",
            link: "settings-packaging_classes",
          },
          {
            title: "MENU-PRODUCTION_SYSTEMS",
            link: "settings-production_systems",
          },
          { title: "MENU-LHF", link: "settings-lhf" },
          { title: "MENU-HELP-TEXTS", link: "settings-help" },
          { title: "MENU-TRANSLATIONS", link: "settings-translations" },
        ],
      },
      {
        title: "MENU-USER_MANAGEMENT",
        icon: "mdi-account-group",
        link: "userManagement",
      },
      "-",
    ],
  }),

  created() {
    switch (this.currentUser.role) {
      // super users
      case "su":
        this.items = this.allItems;
        break;

      // administrators
      case "adm":
        this.items = this.admItems;
        break;

      // operators
      case "op":
        this.items = this.opItems;
        break;

      // warehouse managers
      case "sm":
        this.items = this.smItems;
        break;

      // productionsystem supplier
      case "prdSysSup":
        this.items = this.prdSysSupItems;
        break;

      default:
        this.items = this.smItems;
      // this.items = this.allItems;
    }
  },

  mounted() {
    this.fetchVersions();
  },

  computed: {
    username() {
      return this.currentUser.name;
    },

    mini: {
      get() {
        return this.$vuetify.breakpoint.smAndDown || this.toggleMini;
      },

      set(newValue) {
        this.toggleMini = newValue;
      },
    },

    buttonText() {
      return !this.$vuetify.theme.dark ? "Go Dark" : "Go Light";
    },
  },

  methods: {
    openHelp() {
      this.axios.get("helptexts/byName/INFO").then((res) => {
        this.helpText = res.data.content;
        this.openHelpModal = true;
      });
    },

    fetchVersions() {
      this.axios.get("version").then((res) => {
        this.version = res.data;
      });
    },

    toggleTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    },

    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push({ name: "login" });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar-item-active, v-list-group::v-deep .navbar-item-active{
  color: #1B99A7!important;
  &::before{
    background: transparent!important;
    opacity: 1 !important;
  } 

  background: #404046!important;
}

v-list-group::v-deep .navbar-item-active{
  &::before{

  background: #404046!important;
  }
}

.v-list .v-list-item--active > *{
  color: #1B99A7!important;
  &::before{
    background: transparent!important;
    opacity: 1 !important;
  } 
}
.v-application--is-ltr
  .v-list-group--no-action
  > .v-list-group__items
  > .v-list-item {
  padding-left: 52px;
}

.versions {
  position: absolute;
  bottom: 10px;
  left: 20px;
  right: 0;
  font-size: 11px;
  color: #c5c5c5;
  transition: color 0.3s ease;
  display: flex;
  flex-direction: column;
}
</style>
